import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import InfoCard from './InfoCard';
import Title from '../ui/Title';
import Layout from '../ui/Layout';
import { media } from '../../styles/breakpoints';

const SectionContainer = styled.section`
  ${media.down('sm')} {
    margin: 30px 20px;
  }
`;

const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 40px;
  
  ${media.down('sm')} {
    margin-top: 20px;
    grid-template-columns: 1fr;
  }
`;

const DollarIcon = () => (
  <svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M54.9999 0.833374C25.0999 0.833374 0.833252 25.1 0.833252 55C0.833252 84.9 25.0999 109.167 54.9999 109.167C84.8999 109.167 109.167 84.9 109.167 55C109.167 25.1 84.8999 0.833374 54.9999 0.833374ZM59.7666 86.2V92.9167H50.2874V85.9292C46.2791 84.9542 37.3416 81.7584 33.9291 69.8959L42.8666 66.2667C43.1916 67.4584 46.0083 77.5875 55.8666 77.5875C60.9041 77.5875 66.5916 74.9875 66.5916 68.8667C66.5916 63.6667 62.7999 60.9584 54.2416 57.8709C48.2832 55.7584 36.0958 52.2917 36.0958 39.9417C36.0958 39.4 36.1499 26.9417 50.2874 23.9084V17.0834H59.7666V23.8C69.7333 25.5334 73.3624 33.4959 74.1749 35.8792L65.6166 39.5084C65.0208 37.6125 62.4208 32.25 55.3249 32.25C51.5333 32.25 45.5208 34.2542 45.5208 39.7792C45.5208 44.925 50.1791 46.875 59.8208 50.0709C72.8208 54.5667 76.1249 61.175 76.1249 68.7584C76.1249 83.0042 62.5833 85.7125 59.7666 86.2Z" fill="#007D88"/>
  </svg>
);

const ClientsIcon = () => (
  <div style={{ position: 'relative', display: 'inline-block' }}>
    <svg width="110" height="76" viewBox="0 0 110 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M79.3749 38C86.8499 38 92.8624 31.9334 92.8624 24.4584C92.8624 16.9834 86.8499 10.9167 79.3749 10.9167C71.8999 10.9167 65.8333 16.9834 65.8333 24.4584C65.8333 31.9334 71.8999 38 79.3749 38ZM38.7499 32.5834C47.7416 32.5834 54.9457 25.325 54.9457 16.3334C54.9457 7.34171 47.7416 0.083374 38.7499 0.083374C29.7583 0.083374 22.4999 7.34171 22.4999 16.3334C22.4999 25.325 29.7583 32.5834 38.7499 32.5834ZM79.3749 48.8334C69.4624 48.8334 49.5833 53.8167 49.5833 63.7292V75.9167H109.167V63.7292C109.167 53.8167 89.2874 48.8334 79.3749 48.8334ZM38.7499 43.4167C26.1291 43.4167 0.833252 49.7542 0.833252 62.375V75.9167H38.7499V63.7292C38.7499 59.125 40.5374 51.0542 51.5874 44.9334C46.8749 43.9584 42.3249 43.4167 38.7499 43.4167Z" fill="#007D88"/>
    </svg>
  </div>
);

const CalculatorIcon = () => (
    <svg width="88" height="108" viewBox="0 0 88 108" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.1091 3.65462C-0.909086 7.67281 -0.909086 100.327 3.1091 104.346C5 106.236 17.5273 107.182 44.4727 107.182C79.9273 107.182 83 106.946 85.3636 102.691C88.4364 96.5455 88.4364 11.4546 85.3636 5.30917C83 1.05463 79.9273 0.81826 44.4727 0.81826C17.5273 0.81826 5 1.76372 3.1091 3.65462ZM75.9091 20.9092V31.5455H44H12.0909V20.9092V10.2728H44H75.9091V20.9092ZM28.1636 48.5637C27.6909 52.1092 25.8 54.0001 22.7273 54.0001C19.6546 54.0001 17.7636 52.1092 17.2909 48.5637C16.5818 44.3092 17.5273 43.3637 22.7273 43.3637C27.9273 43.3637 28.8727 44.3092 28.1636 48.5637ZM49.4364 48.5637C48.9636 52.1092 47.0727 54.0001 44 54.0001C40.9273 54.0001 39.0364 52.1092 38.5636 48.5637C37.8546 44.3092 38.8 43.3637 44 43.3637C49.2 43.3637 50.1455 44.3092 49.4364 48.5637ZM70.7091 48.5637C70.2364 52.1092 68.3455 54.0001 65.2727 54.0001C62.2 54.0001 60.3091 52.1092 59.8364 48.5637C59.1273 44.3092 60.0727 43.3637 65.2727 43.3637C70.4727 43.3637 71.4182 44.3092 70.7091 48.5637ZM28.1636 69.8364C27.6909 73.3819 25.5636 75.5092 22.2546 75.9819C17.7636 76.691 16.8182 75.7455 16.8182 70.7819C16.8182 65.8183 18 64.6364 22.9636 64.6364C27.9273 64.6364 28.8727 65.5819 28.1636 69.8364ZM49.9091 70.5455C49.9091 75.2728 48.7273 76.4546 44 76.4546C39.2727 76.4546 38.0909 75.2728 38.0909 70.5455C38.0909 65.8183 39.2727 64.6364 44 64.6364C48.7273 64.6364 49.9091 65.8183 49.9091 70.5455ZM71.1818 70.7819C71.1818 75.7455 70.2364 76.691 65.9818 75.9819C62.4364 75.5092 60.3091 73.3819 59.8364 69.8364C59.1273 65.5819 60.0727 64.6364 65.0364 64.6364C70 64.6364 71.1818 65.8183 71.1818 70.7819ZM28.6364 91.8183C28.6364 96.5455 27.4546 97.7273 22.7273 97.7273C18 97.7273 16.8182 96.5455 16.8182 91.8183C16.8182 87.091 18 85.9092 22.7273 85.9092C27.4546 85.9092 28.6364 87.091 28.6364 91.8183ZM71.1818 91.8183C71.1818 97.491 70.7091 97.7273 54.6364 97.7273C38.5636 97.7273 38.0909 97.491 38.0909 91.8183C38.0909 86.1455 38.5636 85.9092 54.6364 85.9092C70.7091 85.9092 71.1818 86.1455 71.1818 91.8183Z" fill="#007D88"/>
    </svg>
);

const SecureIcon = () => (
    <svg width="88" height="115" viewBox="0 0 88 115" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M76.5001 38.3334H71.0834V27.5001C71.0834 12.5501 58.9501 0.416748 44.0001 0.416748C29.0501 0.416748 16.9167 12.5501 16.9167 27.5001V38.3334H11.5001C5.54175 38.3334 0.666748 43.2084 0.666748 49.1667V103.333C0.666748 109.292 5.54175 114.167 11.5001 114.167H76.5001C82.4584 114.167 87.3334 109.292 87.3334 103.333V49.1667C87.3334 43.2084 82.4584 38.3334 76.5001 38.3334ZM44.0001 87.0834C38.0418 87.0834 33.1667 82.2084 33.1667 76.2501C33.1667 70.2917 38.0418 65.4167 44.0001 65.4167C49.9584 65.4167 54.8334 70.2917 54.8334 76.2501C54.8334 82.2084 49.9584 87.0834 44.0001 87.0834ZM60.7918 38.3334H27.2084V27.5001C27.2084 18.2376 34.7376 10.7084 44.0001 10.7084C53.2626 10.7084 60.7918 18.2376 60.7918 27.5001V38.3334Z" fill="#007D88"/>
    </svg>
);

const AnalitycIcon = () => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.3334 27.75H0.666748V87.3333H22.3334V27.75Z" fill="#007D88"/>
        <path d="M87.3334 49.4167H65.6667V87.3334H87.3334V49.4167Z" fill="#007D88"/>
        <path d="M54.8334 0.666748H33.1667V87.3334H54.8334V0.666748Z" fill="#007D88"/>
    </svg>
);

const TeamIcon = () => (
    <svg width="120" height="109" viewBox="0 0 120 109" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.416748 108.75H22.0834V43.7501H0.416748V108.75ZM119.583 49.1667C119.583 43.2084 114.708 38.3334 108.75 38.3334H74.5709L79.7168 13.5792L79.8792 11.8459C79.8792 9.62508 78.9584 7.56675 77.4959 6.10425L71.7542 0.416748L36.1126 36.1126C34.1084 38.0626 32.9167 40.7709 32.9167 43.7501V97.9167C32.9167 103.875 37.7918 108.75 43.7501 108.75H92.5001C96.9959 108.75 100.842 106.042 102.467 102.142L118.825 63.9542C119.313 62.7084 119.583 61.4084 119.583 60.0001V49.1667Z" fill="#007D88"/>
    </svg>
);

function formatClientCount(count: number | undefined) {
  if (count === undefined || count === null) {
    return '0';
  }
  
  return count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

const advantagesData = (clientsCount?: number) => [
  {
    title: "Учёт рассрочек",
    description: "Безопасное хранение информации о рассрочках. Отслеживание статусов платежей и остатков по договорам",
    icon: <DollarIcon />
  },
  {
    title: (`Огромная база клиентов`),
    description: `Общая база данных насчитывает ${formatClientCount(clientsCount)} клиентов с системой чёрных списков. Просмотр активных договоров и сроков их погашения`,
    icon: <ClientsIcon />
  },
  {
    title: "Контроль сотрудников",
    description: "Разделение пользователей на роли и права. Полный контроль за действиями персонала",
    icon: <SecureIcon />
  },
  {
    title: "Калькулятор рассрочек",
    description: "Встроенный инструмент для быстрого расчёта условий рассрочки с различными параметрами",
    icon: <CalculatorIcon />
  },
  {
    title: "Аналитика и отчёты",
    description: "Автоматическое составление отчётов для инвесторов. Аналитика показателей по периодам",
    icon: <AnalitycIcon />
  },
  {
    title: "Командная работа",
    description: "Лента новостей и чаты для общения сотрудников. Быстрый обмен финансовыми отчётами",
    icon: <TeamIcon />
  }
];

const Advantages: React.FC = () => {
  const [clientsCount, setClientsCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClientsCount = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://web.waypay.one:5001/api/client/count');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setClientsCount(data);
        setError(null);
      } catch (err) {
        setError('Не удалось загрузить количество клиентов');
        console.error('Error fetching clients count:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchClientsCount();
  }, []);

  return (
    <Layout>
      <SectionContainer>
        <Title>
          Почему стоит выбрать WayPay?
          {loading && <span style={{ fontSize: '16px', marginLeft: '12px', color: '#666' }}>Загрузка...</span>}
          {error && <span style={{ fontSize: '14px', marginLeft: '12px', color: 'red' }}>{error}</span>}
        </Title>
        <AdvantagesGrid>
          {advantagesData(clientsCount ?? undefined).map((advantage, index) => (
            <InfoCard
              key={index}
              icon={advantage.icon}
              title={advantage.title}
              description={advantage.description}
            />
          ))}
        </AdvantagesGrid>
      </SectionContainer>
    </Layout>
  );
};

export default Advantages;